import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

interface Step {
  step: number;
  text: string;
  has_image: boolean;
  image_urls: string[];
}

interface Message {
  text: string;
  sender: 'user' | 'agent';
  files?: File[];
  type?: 'text' | 'table' | 'option' | 'json' | 'steps';
  data?: any;
  formattedText?: string;
  rawJson?: string;
  copied?: boolean;
  loading?: boolean;
  completed?: boolean;
  steps?: Step[];
}

@Injectable({
  providedIn: 'root'
})
export class ChatStateService {
  private readonly _messages = new BehaviorSubject<Message[]>([]);
  readonly messages$ = this._messages.asObservable();

  private readonly _isLoading = new BehaviorSubject<boolean>(false);
  readonly isLoading$ = this._isLoading.asObservable();

  private readonly _selectedFiles = new BehaviorSubject<File[]>([]);
  readonly selectedFiles$ = this._selectedFiles.asObservable();

  private readonly _chatInput = new BehaviorSubject<string>('');
  readonly chatInput$ = this._chatInput.asObservable();

  // chat-state.service.ts

private readonly _openChat = new Subject<void>();
readonly openChat$ = this._openChat.asObservable();

// Call this to open chat programmatically
public openChat(): void {
  this._openChat.next();
}

  constructor() {
    if (this.messages.length === 0) {
      this.addMessage({ text: 'Which action do you need help with?', sender: 'agent' });
    }
  }

  get messages(): Message[] {
    return this._messages.getValue();
  }

  set messages(val: Message[]) {
    this._messages.next(val);
  }

  addMessage(message: Message) {
    this.messages = [...this.messages, message];
  }

  get isLoading(): boolean {
    return this._isLoading.getValue();
  }

  set isLoading(val: boolean) {
    this._isLoading.next(val);
  }

  get selectedFiles(): File[] {
    return this._selectedFiles.getValue();
  }

  set selectedFiles(val: File[]) {
    this._selectedFiles.next(val);
  }

  addFile(file: File) {
    this.selectedFiles = [...this.selectedFiles, file];
  }

  removeFile(file: File) {
    this.selectedFiles = this.selectedFiles.filter(f => f !== file);
  }

  clearAll() {
    this.messages = [];
    this.isLoading = false;
    this.selectedFiles = [];
    this.addMessage({ text: 'Which action do you need help with?', sender: 'agent' });
  }

  public setChatInput(message: string): void {
    this._chatInput.next(message);
  }
}